export default {"src":"/_next/static/media/maven-detaling-logo-dark.ae3fcf98.svg","height":76,"width":316};